module.exports = __webpack_public_path__ + "img/img.c31ec6c6.png";